import { render, staticRenderFns } from "./comp-dialog.vue?vue&type=template&id=1e2f348b&scoped=true&"
import script from "./comp-dialog.vue?vue&type=script&lang=ts&"
export * from "./comp-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./comp-dialog.vue?vue&type=style&index=0&id=1e2f348b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@rakete/cli-plugin-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2f348b",
  null
  
)

export default component.exports